<template>
  <div class="profile">
    <a class="profile__link" href="/my-profile">
      <span class="link profile__title">Личный кабинет</span>
      <div class="profile__avatar-container">
        <img v-if="avatarSrc" class="profile__avatar" :src="avatarSrc" alt="photo" />
        <ProfileIcon v-else class="profile__icon" alt="profile" />
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref } from "vue";
import ProfileIcon from '@/common/icons/ProfileIcon.vue'
import api from "@/myProfileSection/api";

const avatarSrc: Ref<string> = ref('')

onMounted(async () => {
  const userInfo = await api.getUserInfo()

  if (userInfo.avatar) {
    avatarSrc.value = `/assets/uploads/user_avatars/${userInfo.avatar}`
  }
})

</script>

<style scoped>
  .profile {
    display: flex;
    align-items: center;
    gap: 10px;

    &__title {
      font-size: 14px;
      line-height: 16px;
      font-weight: 600;
    }

    &__avatar-container {
      display: flex;
      width: 44px;
      height: 44px;
      background: #1E2023;
      border-radius: 12px;
    }

    &__link {
      display: flex;
      height: 44px;
      cursor: pointer;
      border-radius: 12px;
      align-items: center;
      text-decoration: none;
      color: white;
      gap: 8px;
    }

    &__avatar {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      object-fit: cover;
    }

    &__icon {
      height: 20px;
      opacity: .5;
      width: 16px;
      margin: auto;
    }
  }
</style>